import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { RoundCassette } from "../../../RoundCassette";
import { RankingResult } from "../../../RankingResult";
import { ReportGraph } from "../../../ReportGraph";
import { COMMON_PROBLEMS, RANK_TEXTS, RESULT_SUB_TEXT, SEARCH_SUGGESTIONS } from "./constants";
import { type GraphCassetteProps } from "../../type";
import * as styles from "./styles.css";

type Props = {
  className?: string;
} & GraphCassetteProps;

export const GraphCassette: FC<Props> = ({
  className,
  jobTypeName,
  average,
  resultType,
  result,
  reportGraph,
}) => {
  const rank = result.rank || "normal";
  const percentageRange = `${result.percentileMin}-${result.percentileMax}`;
  return (
    <RoundCassette className={`${styles.cassette} ${className || ""}`} hasBorder>
      <div className={styles.inner}>
        <RankingResult {...result} />
        <p className={styles.average}>
          {jobTypeName}の平均：{average}
        </p>
        <p className={styles.assessmentText}>
          【{jobTypeName}】業界において、あなたの【{result.title}】は、全体の【{percentageRange}
          %】に位置し、【
          {RANK_TEXTS[rank]}】ランクに該当します。
        </p>
        <p className={styles.assessmentSubText}>{RESULT_SUB_TEXT[rank]}</p>
        <div className={styles.graphLayout}>
          <div className={styles.graphLayoutItem}>
            <ReportGraph {...reportGraph} />
          </div>
          {rank === "potential" && (
            <div className={styles.graphLayoutItem}>
              <div className={styles.commonProblems}>
                <p className={styles.potentialSectionHeading}>よくある悩み</p>
                <ul className={styles.commonProblemsList}>
                  {COMMON_PROBLEMS[resultType].map((problem) => (
                    <li key={problem} className={styles.commonProblemsListItem}>
                      <Icon name="message" className={styles.commonProblemsListIcon} />
                      {problem}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles.searchSuggestions}>
                <p className={styles.potentialSectionHeading}>
                  こんな条件で探してみると良いでしょう
                </p>
                <ul className={styles.searchSuggestionsList}>
                  {SEARCH_SUGGESTIONS[resultType].map((requirement) => (
                    <li key={requirement} className={styles.searchSuggestionsListItem}>
                      <img
                        src="/images/user_frontend/global/icon/icn_tag.svg"
                        alt="タグのアイコン"
                        width="15"
                        height="16"
                        loading="lazy"
                        className={styles.searchSuggestionsTagIcon}
                      />
                      {requirement}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </RoundCassette>
  );
};
